const e=(e,t)=>{let o;return(...n)=>{clearTimeout(o),o=setTimeout((()=>e(...n)),t)}},t=(e,t)=>{let o,n;return(...r)=>{n?(clearTimeout(o),o=setTimeout((()=>{Date.now()-n>=t&&(e(...r),n=Date.now())}),t-(Date.now()-n))):(e(...r),n=Date.now())}};export{e as debounce,t as throttle};
//# sourceMappingURL=events.js.map
